export const timelineData = [
  {
    text: [
      "Building voice-to-voice AI platform for patient calls on Twilio with patient record lookups, quick specialized-line transfers, and urgency detection.",
    ],
    date: "Summer 2025",
    category: {
      tag: "Switchboard, MD",
      color: "#00C2FD",
    },
    link: {
      url: "https://www.switchboardmd.com/",
      text: "See More",
    },
    skills: [
      {
        skill: "Twilio",
        skillLink: "https://www.twilio.com/en-us",
      },
      { skill: "React", inline: "ci-react", skillLink: "https://react.dev/" },
      {
        skill: "TypeScript",
        inline: "ci-typescript",
        skillLink: "https://www.typescriptlang.org/",
      },
      {
        skill: "JavaScript",
        inline: "ci-javascript",
        skillLink: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
      },
      {
        skill: "GraphQL",
        inline: "ci-graphql",
        skillLink: "https://graphql.org/",
      },
      {
        skill: "Bedrock",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/bedrock/",
      },
    ],
  },
  {
    text: ["Enabling real-time call transcription with Amazon Chime SDK."],
    date: "Summer 2025",
    category: {
      tag: "Switchboard, MD",
      color: "#00C2FD",
    },
    link: {
      url: "https://www.switchboardmd.com/",
      text: "See More",
    },
    skills: [
      {
        skill: "Chime SDK",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/chime/chime-sdk/",
      },
      {
        skill: "Python",
        inline: "ci-python",
        skillLink: "https://www.python.org/",
      },
      { skill: "React", inline: "ci-react", skillLink: "https://react.dev/" },
      {
        skill: "TypeScript",
        inline: "ci-typescript",
        skillLink: "https://www.typescriptlang.org/",
      },
      {
        skill: "JavaScript",
        inline: "ci-javascript",
        skillLink: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
      },
      {
        skill: "Amplify",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/amplify/",
      },
      {
        skill: "Lambda",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/lambda/",
      },
      {
        skill: "Bedrock",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/bedrock/",
      },
      {
        skill: "Cognito",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/cognito/",
      },
    ],
  },
  {
    text: ["Constructing a PBX Server with Asterisk for voice-to-voice AI."],
    date: "Summer 2025",
    category: {
      tag: "Switchboard, MD",
      color: "#00C2FD",
    },
    link: {
      url: "https://www.switchboardmd.com/",
      text: "See More",
    },
    skills: [
      { skill: "Asterisk", skillLink: "https://www.asterisk.org/" },
      {
        skill: "EC2",
        inline: "ci-ec2",
        skillLink: "https://aws.amazon.com/ec2/",
      },
      {
        skill: "Linux",
        inline: "ci-linux",
        skillLink: "https://www.linux.org/",
      },
      {
        skill: "VoIP",
        skillLink:
          "https://www.fcc.gov/general/voice-over-internet-protocol-voip#:~:text=Voice%20over%20Internet%20Protocol%20(VoIP)%2C%20is%20a%20technology%20that,(or%20analog)%20phone%20line.",
      },
    ],
  },
  {
    text: [
      "Began my first semester as a teaching assistant for CIS 1210: Data Structures and Algorithms.",
    ],
    date: "Spring 2025",
    category: {
      tag: "CIS 1210 Teaching Staff",
      color: "#0600ff",
    },
    link: {
      url: "https://www.cis.upenn.edu/~cis1210/current/",
      text: "See More",
    },
    skills: [
      { skill: "Data Structures" },
      {
        skill: "Java",
        inline: "ci-java",
        skillLink: "https://www.java.com/en/",
      },
      { skill: "Teaching", inline: "ci-scholar" },
    ],
  },
  {
    text: [
      "Researched in the xLab: Safe Autonomous Systems Lab, developing lane detection software F1Eighteenth: a 1/18th scale autonomous car.",
    ],
    date: "Fall - Winter 2024",
    category: {
      tag: "xLab",
      color: "#d52a6c",
    },
    link: {
      url: "https://xlab.upenn.edu/",
      text: "See More",
    },
    skills: [
      {
        skill: "OpenCV",
        inline: "ci-opencv",
        skillLink: "https://opencv.org/",
      },
      {
        skill: "Python",
        inline: "ci-python",
        skillLink: "https://www.python.org/",
      },
    ],
  },
  {
    text: ["Served as a project mentor to onboard new android developers."],
    date: "Fall 2024",
    category: {
      tag: "PennLabs",
      color: "#a90af5",
    },
    link: {
      url: "https://pennlabs.org/products/penn-mobile",
      text: "See More",
    },
    skills: [
      {
        skill: "Android Studio",
        inline: "ci-androidstudio",
        skillLink:
          "https://developer.android.com/studio?_gl=1*mtik*_up*MQ..&gclid=CjwKCAjw3f_BBhAPEiwAaA3K5H-KNxG96YtdGuo7wbrqczljmzRuqHhsMxWdadLJom3asHO6hS53oRoCo0EQAvD_BwE&gclsrc=aw.ds&gbraid=0AAAAAC-IOZluaKqB6_LHoqYKXYAd00Wgs",
      },
      {
        skill: "Kotlin",
        inline: "ci-kotlin",
        skillLink: "https://kotlinlang.org/",
      },
    ],
  },
  {
    text: [
      "Launched a subletting marketplace using the Google Maps API (100+ active listings).",
    ],
    date: "Spring - Fall 2024",
    category: {
      tag: "PennLabs",
      color: "#a90af5",
    },
    link: {
      url: "https://pennlabs.org/products/penn-mobile",
      text: "See More",
    },
    skills: [
      {
        skill: "Android Studio",
        inline: "ci-androidstudio",
        skillLink:
          "https://developer.android.com/studio?_gl=1*mtik*_up*MQ..&gclid=CjwKCAjw3f_BBhAPEiwAaA3K5H-KNxG96YtdGuo7wbrqczljmzRuqHhsMxWdadLJom3asHO6hS53oRoCo0EQAvD_BwE&gclsrc=aw.ds&gbraid=0AAAAAC-IOZluaKqB6_LHoqYKXYAd00Wgs",
      },
      {
        skill: "Kotlin",
        inline: "ci-kotlin",
        skillLink: "https://kotlinlang.org/",
      },
    ],
  },
  {
    text: [
      "Created the MDAware Demo App to showcase patient message classification model features, logic, and impact; used in a Google Ventures pitch and helped drive two contract expansions (≈ $400k ARR pipeline).",
    ],
    date: "Summer 2024",
    category: {
      tag: "Switchboard, MD",
      color: "#00C2FD",
    },
    link: {
      url: "https://www.switchboardmd.com/",
      text: "See More",
    },
    skills: [
      { skill: "React", inline: "ci-react", skillLink: "https://react.dev/" },
      {
        skill: "GraphQL",
        inline: "ci-graphql",
        skillLink: "https://graphql.org/",
      },
      {
        skill: "Python",
        inline: "ci-python",
        skillLink: "https://www.python.org/",
      },
      {
        skill: "TypeScript",
        inline: "ci-typescript",
        skillLink: "https://www.typescriptlang.org/",
      },
      {
        skill: "JavaScript",
        inline: "ci-javascript",
        skillLink: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
      },
      {
        skill: "Tailwind CSS",
        inline: "ci-tailwindcss",
        skillLink: "https://tailwindcss.com/",
      },
      {
        skill: "Amplify",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/amplify/",
      },
      {
        skill: "Lambda",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/lambda/",
      },
      {
        skill: "Cognito",
        inline: "ci-aws",
        skillLink: "https://aws.amazon.com/cognito/",
      },
    ],
  },
  {
    text: [
      "Built the MDAware Pilot Assessment App, a data visualization tool to help prospective clients interpret various proprietary models’ outputs on their hospital datasets.",
    ],
    date: "Summer 2024",
    category: {
      tag: "Switchboard, MD",
      color: "#00C2FD",
    },
    link: {
      url: "https://www.switchboardmd.com/",
      text: "See More",
    },
    skills: [
      { skill: "React", inline: "ci-react", skillLink: "https://react.dev/" },
      {
        skill: "TypeScript",
        inline: "ci-typescript",
        skillLink: "https://www.typescriptlang.org/",
      },
      {
        skill: "Tailwind CSS",
        inline: "ci-tailwindcss",
        skillLink: "https://tailwindcss.com/",
      },
    ],
  },
  {
    text: [
      "Created a mobile homepage feature for group study room booking & display.",
    ],
    date: "Spring 2024",
    category: {
      tag: "PennLabs",
      color: "#a90af5",
    },
    link: {
      url: "https://pennlabs.org/products/penn-mobile",
      text: "See More",
    },
    skills: [
      {
        skill: "Android Studio",
        inline: "ci-androidstudio",
        skillLink:
          "https://developer.android.com/studio?_gl=1*mtik*_up*MQ..&gclid=CjwKCAjw3f_BBhAPEiwAaA3K5H-KNxG96YtdGuo7wbrqczljmzRuqHhsMxWdadLJom3asHO6hS53oRoCo0EQAvD_BwE&gclsrc=aw.ds&gbraid=0AAAAAC-IOZluaKqB6_LHoqYKXYAd00Wgs",
      },
      {
        skill: "Kotlin",
        inline: "ci-kotlin",
        skillLink: "https://kotlinlang.org/",
      },
    ],
  },
  {
    text: [
      "Worked under Dr. Dejun Yang to develop a biometrics-based fraud/theft detection application using SVM modeling in Android Studio. Later ported to iOS.",
    ],
    date: "Summer 2022",
    category: {
      tag: "NEMOS Lab",
      color: "#47b84a",
    },
    link: {
      url: "https://nemos.mines.edu/",
      text: "See More",
    },
    skills: [
      {
        skill: "Android Studio",
        inline: "ci-androidstudio",
        skillLink:
          "https://developer.android.com/studio?_gl=1*mtik*_up*MQ..&gclid=CjwKCAjw3f_BBhAPEiwAaA3K5H-KNxG96YtdGuo7wbrqczljmzRuqHhsMxWdadLJom3asHO6hS53oRoCo0EQAvD_BwE&gclsrc=aw.ds&gbraid=0AAAAAC-IOZluaKqB6_LHoqYKXYAd00Wgs",
      },
      {
        skill: "Xcode",
        inline: "ci-xcode",
        skillLink: "https://developer.apple.com/xcode/",
      },
      {
        skill: "MATLAB",
        inline: "ci-matlab",
        skillLink: "https://www.mathworks.com/products/matlab.html",
      },
      {
        skill: "Java",
        inline: "ci-java",
        skillLink: "https://www.java.com/en/",
      },
      {
        skill: "Swift",
        inline: "ci-swift",
        skillLink: "https://www.swift.org/",
      },
    ],
  },
];
